var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BehaviorSubject } from 'rxjs';
import { SETTINGS } from '../../../../../defs/schema/public/Users';
import { SettingsService } from '../../settings/settings.service';
import * as i0 from "@angular/core";
import * as i1 from "../../settings/settings.service";
var ControlFlowService = (function () {
    function ControlFlowService(settingsService) {
        var _this = this;
        this.settingsService = settingsService;
        this.valid = new BehaviorSubject(null);
        this.isCollapsed = new BehaviorSubject(this.settingsService.settings[SETTINGS.SIDEBAR_COLLAPSED]);
        this.leftOffset = new BehaviorSubject(ControlFlowService.LEFT_SIDEBAR_OFFSET[+this.isCollapsed.value]);
        this.rightOffset = new BehaviorSubject('0');
        this.valid$ = this.valid.asObservable();
        this.isCollapsed$ = this.isCollapsed.asObservable();
        this.leftOffset$ = this.leftOffset.asObservable();
        this.rightOffset$ = this.rightOffset.asObservable();
        this.settingsService.settingsRestored.subscribe(function (settings) {
            if (_this.isCollapsed.value !== settings[SETTINGS.SIDEBAR_COLLAPSED]) {
                _this.toggleSidebar();
            }
        });
    }
    ControlFlowService.prototype.validate = function (valid) {
        this.valid.next(valid);
    };
    ControlFlowService.prototype.toggleSidebar = function () {
        var _this = this;
        var isCollapsed = !this.isCollapsed.value;
        this.isCollapsed.next((this.settingsService.settings[SETTINGS.SIDEBAR_COLLAPSED] = isCollapsed));
        (function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2, this.settingsService.save()];
        }); }); })();
        this.leftOffset.next(ControlFlowService.LEFT_SIDEBAR_OFFSET[+isCollapsed]);
    };
    ControlFlowService.LEFT_SIDEBAR_OFFSET = ['240px', '50px'];
    ControlFlowService.ngInjectableDef = i0.defineInjectable({ factory: function ControlFlowService_Factory() { return new ControlFlowService(i0.inject(i1.SettingsService)); }, token: ControlFlowService, providedIn: "root" });
    return ControlFlowService;
}());
export { ControlFlowService };
